export enum BarChartName {
	StackedBarChart = 'stacked-bar-chart'
}
